// React
import { useState, useEffect } from 'react'

// Styles
import './BoardModal.css'

const EMOJIS = ['🌐','📋','🚀','⭐','🎯','📊','🔧','✏️','🗂️','💡','🔥','📌']

const BoardModal = ({ isOpen, onClose, onSave, board }) => {
    const [name, setName] = useState('')
    const [emoji, setEmoji] = useState('📋')
    const [touched, setTouched] = useState(false)

    useEffect(() => {
        if (isOpen) {
            setName(board ? board.name : '')
            setEmoji(board ? board.emoji ?? '📋' : '📋')
            setTouched(false)
        }
    }, [isOpen, board])

    if (!isOpen) return null

    const validate = (v) => {
        if (!v || !v.trim()) return 'O nome do quadro é obrigatório.'
        if (v.trim().length < 3) return 'O nome deve ter entre 3 e 100 caracteres.'
        if (v.trim().length > 100) return 'O nome deve ter entre 3 e 100 caracteres.'
        return null
    }

    const error = validate(name)
    const isFormValid = error === null

    const handleSave = () => {
        setTouched(true)
        if (!isFormValid) return
        onSave({ name: name.trim(), emoji })
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleSave()
    }

    return (
        <div className='BoardModal-overlay' onClick={onClose}>
            <div className='BoardModal' onClick={e => e.stopPropagation()}>
                <div className='BoardModal-header'>
                    <h2>{board ? 'Editar Quadro' : 'Novo Quadro'}</h2>
                    <button className='BoardModal-close' onClick={onClose}>✕</button>
                </div>

                <div className='BoardModal-body'>
                    <div className='BoardModal-field'>
                        <label>Nome</label>
                        <input
                            type='text'
                            placeholder='Ex: Projeto Frontend'
                            value={name}
                            onChange={e => setName(e.target.value)}
                            onBlur={() => setTouched(true)}
                            onKeyDown={handleKeyDown}
                            autoFocus
                        />
                        {touched && error &&
                            <span className='BoardModal-field-error'>{error}</span>
                        }
                    </div>

                    <div className='BoardModal-field'>
                        <label>Ícone</label>
                        <div className='BoardModal-emojis'>
                            {EMOJIS.map(e => (
                                <button
                                    key={e}
                                    className={`BoardModal-emoji-btn ${emoji === e ? 'selected' : ''}`}
                                    onClick={() => setEmoji(e)}
                                    type='button'
                                >
                                    {e}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

                <div className='BoardModal-footer'>
                    <button className='BoardModal-btn-cancel' onClick={onClose}>Cancelar</button>
                    <button
                        className='BoardModal-btn-save'
                        onClick={handleSave}
                        disabled={!isFormValid}
                    >
                        {board ? 'Salvar' : 'Criar'}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default BoardModal